/**
 * FeaturePath: 會員系統-其它-條款-服務條款
 * Accountable: Landy Chu, AlexCH Cheng
 */

// ----- import npm modules -----
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// ----- import local modules -----
import { getServiceTerms } from '../../../actions/article';

// ----- import css -----
import styles from './styles.css';

// ----- function component: 服務條款元件 -----
const ServiceTermsPage = ({
  content, // 服務條款內容
  onGetServiceTerms, // 取得服務條款內容
}) => {
  useEffect(() => {
    // 取得服務條款內容
    onGetServiceTerms();
  }, []);

  return (
    <div
      className={styles.container}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

function mapStateToProps({
  article: {
    serviceTermsHtml: content,
  },
}) {
  return {
    content,
  };
}

function mapDispatchToProps(dispatch) {
  return ({
    onGetServiceTerms: () => dispatch(getServiceTerms()),
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTermsPage);
